export const toMegabytes = (n: number) => Math.floor(Number(n) / (1024 * 1024))
